export const GEOFENCE_ACTIONS = [
    {
        id: 'notification',
        name: 'notification',
        icon: 'bell'
    }
]
